// Firma de los correos que salen por Graph (v2.8, CONTRATO §12.2; backend/app/api/firmas.py).
import { solicitar } from './http';

export type OrigenFirma = 'outlook' | 'manual' | 'generada';

export interface FirmaCorreo {
  buzon: string;
  origen: OrigenFirma;
  /** HTML saneado, con las imágenes resueltas como data: para la vista previa. */
  html: string;
  actualizado: string | null;
  actualizado_por: string | null;
  revisado: string | null;
  es_preventa?: boolean;
  puede_editar?: boolean;
  resultado?: OrigenFirma;
}

export const ETIQUETA_ORIGEN_FIRMA: Record<OrigenFirma, string> = {
  outlook: 'Tomada de Outlook',
  manual: 'Editada en UPK INNOVA',
  generada: 'Generada con los datos del directorio',
};

const b = (buzon: string) => encodeURIComponent(buzon);

export const firmas = {
  listar: () => solicitar<{ items: FirmaCorreo[] }>({ metodo: 'GET', ruta: '/api/firmas' }),
  deComunicacion: (id: number) => solicitar<FirmaCorreo>({ metodo: 'GET', ruta: `/api/firmas/de-comunicacion/${id}` }),
  guardar: (buzon: string, html: string) => solicitar<FirmaCorreo>({ metodo: 'PUT', ruta: `/api/firmas/${b(buzon)}`, cuerpo: { html } }),
  desdeOutlook: (buzon: string) => solicitar<FirmaCorreo>({ metodo: 'POST', ruta: `/api/firmas/${b(buzon)}/outlook`, cuerpo: {} }),
  restablecer: (buzon: string) => solicitar<FirmaCorreo>({ metodo: 'DELETE', ruta: `/api/firmas/${b(buzon)}` }),
};
